import { Card } from './card'
import { BidType } from '../types/bid.type'
import { GamePlayerOrder } from '../types/game-player-order'
import { Trick, trickNull } from './trick'
import { CardArray } from './card.array'
import { Bid } from './bid'
import { DefendOption, defendOptionNull } from './defend-option'

interface GamePlayerProps {
  readonly userId: string
  readonly username: string
  readonly cards: Card[]
  readonly bid: BidType
  readonly isTurnToPlay: boolean
  readonly playerOrder: GamePlayerOrder
  readonly hasPassedBid: boolean
  readonly hasPlacedBid: boolean
  readonly shouldShowCardsFaceUp: boolean
  readonly hasDeclaredContract: boolean
  readonly hasDeclaredDefendOption: boolean
  readonly defendOption: DefendOption
  readonly doublingCountRoundsPlayed: number
  readonly hasDoublingCountRoundsLeft: boolean
  readonly leftOpponentUsername: string
  readonly rightOpponentUsername: string
  readonly shouldShowTrick: boolean
  readonly trick: Trick
  readonly isPlayingGame: boolean
  readonly tricksWon: number
  readonly previousTrick: Trick
  readonly hasPassedGame: boolean
  readonly originalCards: Card[]
  readonly hasConfirmedResults: boolean
  readonly shouldShowTricksWon: boolean
}

export class GamePlayer {
  private readonly playerOrder = this.gamePlayerProps.playerOrder
  private _cards = CardArray.from(this.gamePlayerProps.cards)

  public readonly userId = this.gamePlayerProps.userId
  public readonly username = this.gamePlayerProps.username
  public readonly bid = new Bid(this.gamePlayerProps.bid)
  public readonly isTurnToPlay = this.gamePlayerProps.isTurnToPlay
  public readonly hasPassedBid = this.gamePlayerProps.hasPassedBid
  public readonly hasPlacedBid = this.gamePlayerProps.hasPlacedBid

  public readonly shouldShowCardsFaceUp =
    this.gamePlayerProps.shouldShowCardsFaceUp

  public readonly hasDeclaredContract = this.gamePlayerProps.hasDeclaredContract

  public readonly hasDeclaredDefendOption =
    this.gamePlayerProps.hasDeclaredDefendOption

  public readonly defendOption = this.gamePlayerProps.defendOption

  public readonly doublingCountRoundsPlayed =
    this.gamePlayerProps.doublingCountRoundsPlayed

  public readonly hasDoublingCountRoundsLeft =
    this.gamePlayerProps.hasDoublingCountRoundsLeft

  public readonly leftOpponentUsername =
    this.gamePlayerProps.leftOpponentUsername

  public readonly rightOpponentUsername =
    this.gamePlayerProps.rightOpponentUsername

  public readonly shouldShowTrick = this.gamePlayerProps.shouldShowTrick
  public readonly trick = this.gamePlayerProps.trick
  public readonly isPlayingGame = this.gamePlayerProps.isPlayingGame
  public readonly tricksWon = this.gamePlayerProps.tricksWon
  public readonly hasPassedGame = this.gamePlayerProps.hasPassedGame
  public readonly previousTrick = this.gamePlayerProps.previousTrick

  public readonly originalCards: Card[] = CardArray.from(
    this.gamePlayerProps.originalCards,
  ).sortCards()

  public readonly hasConfirmedResults = this.gamePlayerProps.hasConfirmedResults
  public readonly shouldShowTricksWon = this.gamePlayerProps.shouldShowTricksWon

  public constructor(private gamePlayerProps: GamePlayerProps) {}

  public getCards(): Card[] {
    return this._cards.sortCards()
  }

  public addCard(card: Card) {
    this._cards = this._cards.filter((item) => item)
    this._cards.push(card)
  }

  public removeCard(card: Card) {
    this._cards = this._cards.filter((item) => item !== card)
  }

  public getIsForehand() {
    return this.playerOrder === 'Forehand'
  }

  public getIsMiddlehand() {
    return this.playerOrder === 'Middlehand'
  }
}

export const gamePlayerNull: GamePlayer = new GamePlayer({
  userId: '',
  username: '',
  cards: [],
  bid: 'Two',
  isTurnToPlay: false,
  playerOrder: 'Forehand',
  hasPassedBid: false,
  hasPlacedBid: false,
  shouldShowCardsFaceUp: false,
  hasDeclaredContract: false,
  hasDeclaredDefendOption: false,
  defendOption: defendOptionNull,
  doublingCountRoundsPlayed: 0,
  hasDoublingCountRoundsLeft: false,
  leftOpponentUsername: '',
  rightOpponentUsername: '',
  shouldShowTrick: false,
  trick: trickNull,
  isPlayingGame: false,
  tricksWon: 0,
  previousTrick: trickNull,
  hasPassedGame: false,
  originalCards: [],
  hasConfirmedResults: false,
  shouldShowTricksWon: false,
})
